import {
  faCircleCheck,
  faTriangleExclamation,
} from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLingui } from '@lingui/react/macro';
import classNames from 'classnames';

import type { ClaimTabRow } from './buildClaimTabData';

interface ClaimTreatmentCardProps {
  row: ClaimTabRow;
}

export const ClaimTreatmentCard = ({ row }: ClaimTreatmentCardProps) => {
  const { t } = useLingui();

  const quadrantLabel = row.quadrant
    ? {
        LL: t`Lower Left Quadrant`,
        LR: t`Lower Right Quadrant`,
        UL: t`Upper Left Quadrant`,
        UR: t`Upper Right Quadrant`,
      }[row.quadrant]
    : null;
  const subtitleParts = [row.txDescription];

  if (quadrantLabel) {
    subtitleParts.push(quadrantLabel);
  }

  return (
    <div className="vai-w-full vai-rounded-[6px] vai-border vai-border-zinc-800 vai-bg-[rgba(41,46,59,0.24)] vai-p-4">
      <div className="vai-flex vai-items-start vai-justify-between vai-gap-2">
        <div className="vai-min-w-0">
          <p className="vai-text-base vai-font-semibold vai-leading-6 vai-text-zinc-300">
            {row.txCode}
          </p>
          <p className="vai-text-[12px] vai-leading-4 vai-text-zinc-400">
            {subtitleParts.join(' - ')}
          </p>
        </div>
        <FontAwesomeIcon
          className={classNames('vai-mt-0.5 vai-text-[14px]', {
            'vai-text-[#D4A700]': row.status !== 'clear',
            'vai-text-green-500': row.status === 'clear',
          })}
          icon={row.status === 'clear' ? faCircleCheck : faTriangleExclamation}
        />
      </div>
      {row.status === 'clear' ? (
        <div className="vai-mt-3 vai-flex vai-items-center vai-gap-1.5">
          <span className="vai-text-[12px] vai-leading-[17px] vai-text-green-400">
            •
          </span>
          <p className="vai-text-[14px] vai-leading-5 vai-text-zinc-400">
            {t`No issues found.`}
          </p>
        </div>
      ) : (
        <div className="vai-mt-3 vai-space-y-1">
          {row.messages.map((message) => (
            <div
              key={`${row.treatmentKey}-${message.type}-${message.text}`}
              className="vai-flex vai-items-start vai-gap-1"
            >
              <span className="vai-text-[12px] vai-leading-[17px] vai-text-zinc-400">
                •
              </span>
              <p className="vai-flex-1 vai-text-[14px] vai-leading-5 vai-text-zinc-400">
                {message.text}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
